import { useContext, useState } from 'react';
import Container from 'react-bootstrap/Container';
import { ThemeContext } from '../../../context/theme-context';
import ListaPessoa from './ListaPessoa';
import { FormPessoa } from './FormPessoa';
import { PersonPath, getPersonType } from './FormPessoa/personForm';

interface Props {
  path: PersonPath;
}

type View =
  | { mode: 'list' }
  | { mode: 'form'; person: any; editing: boolean; notice?: string; key: number };

/** Página única para clientes, fornecedores, funcionários e transportadoras. */
export default function CadPessoaPage({ path }: Props) {
  const { collapsed } = useContext(ThemeContext);
  const type = getPersonType(path);
  const [view, setView] = useState<View>({ mode: 'list' });

  const openForm = (person: any, editing: boolean, notice?: string) =>
    setView({ mode: 'form', person, editing, notice, key: Date.now() });

  return (
    <Container className={collapsed ? 'contenteLayoutCollapsed' : 'contenteLayout'}>
      {view.mode === 'list' ? (
        <ListaPessoa
          Title={type.plural}
          Path={path}
          OnAddNewCli={(open: boolean) => open && openForm({}, false)}
          onEditItem={(item: any) => openForm(item, true)}
        />
      ) : (
        <FormPessoa
          key={view.key}
          Title={type.label}
          Path={path}
          people={view.person}
          editando={view.editing}
          notice={view.notice}
          OnAddNewPeople={(open: boolean) => !open && setView({ mode: 'list' })}
          onOpenExisting={(person: any, notice?: string) => openForm(person, true, notice)}
        />
      )}
    </Container>
  );
}
